"use client";
"use no memo";

// TanStack Table v8 mutates stable table instances; toolbar state must be read live.
import { Cross2Icon } from "@radix-ui/react-icons";
import { Table } from "@tanstack/react-table";
import { useLabResultsColumnFilters, type LabResultsWithClassification } from "@/src/components/cards/lab-results-card/lab-results-columns";
import { Button } from "@/src/components/shadcn/ui/button";
import { DataTableFacetedFilter } from "@/src/components/tables/data-table-faceted-filter";
import { DataTableViewOptions } from "@/src/components/tables/data-table-view-options";
import { getClassificationDisplay } from "@/src/lib/utils/classification";
import { Classification } from "@/src/models/constants/classifications";
interface LabResultsToolbarProps {
  table: Table<LabResultsWithClassification>;
}
export function LabResultsToolbar({
  table
}: LabResultsToolbarProps) {
  const isFiltered = (table.getState().columnFilters?.length ?? 0) > 0;
  const [_columnFilters, setColumnFilters] = useLabResultsColumnFilters();

  // Get unique values for filters
  const rows = table.getFilteredRowModel()?.rows || [];
  const labTypes = Array.from(new Set(rows.flatMap(row => row.original.labTypesAndResults?.map((item: {
    typeOfLab: any;
  }) => item.typeOfLab) || []).filter(Boolean)));
  const classifications = Array.from(new Set(rows.map(row_0 => row_0.original.classification).filter(Boolean)));
  return <div className="flex items-center justify-between">
      <div className="flex flex-1 items-center space-x-2 px-4 py-2 text-muted-foreground">
        {table.getColumn("classification") && <DataTableFacetedFilter column={table.getColumn("classification")} title="Classification" options={classifications.map(classification => ({
        label: getClassificationDisplay(classification as Classification),
        value: classification
      }))} onChange={values => {
        setColumnFilters({
          labResultsClassification: values
        });
      }} />}
        {table.getColumn("labTypesAndResults") && <DataTableFacetedFilter column={table.getColumn("labTypesAndResults")} title="Lab Type" options={labTypes.map(type => ({
        label: type,
        value: type
      }))} onChange={values_0 => {
        setColumnFilters({
          typeOfLab: values_0
        });
      }} />}
        {table.getColumn("needsSignature") && <DataTableFacetedFilter column={table.getColumn("needsSignature")} title="Signature" options={[{
        label: "Yes",
        value: "true"
      }, {
        label: "No",
        value: "false"
      }]} onChange={values_1 => {
        setColumnFilters({
          needsSignature: values_1
        });
      }} />}
        {isFiltered && <Button variant="ghost" onClick={() => {
        setColumnFilters(null);
        table.resetColumnFilters();
      }} className="px-2 lg:px-3">
            <span className="text-muted-foreground text-xs">Reset</span>
            <Cross2Icon className="ml-2 h-3 w-3 relative top-[0.9px]" />
          </Button>}
      </div>
      <div className="flex items-center space-x-2 px-4 py-2">
        <DataTableViewOptions table={table} />
      </div>
    </div>;
}